// ?use_ios_ui — the iOS close alert (Cancel / destructive Close), drawn as
// a centred dialog: a web page has no native alert inside an AR session.

import { IOS_UI_FONT } from '@/components/ios-ui/ios-ui-palette/ios-ui-palette'

interface CloseConfirmProps {
  title: string
  message: string
  onCancel: () => void
  onConfirm: () => void
}

export function CloseConfirm({ title, message, onCancel, onConfirm }: CloseConfirmProps) {
  return (
    <div
      role="alertdialog"
      aria-labelledby="ios-close-title"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.35)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: IOS_UI_FONT,
        pointerEvents: 'auto',
        zIndex: 50,
      }}
    >
      <div style={{ width: 270, borderRadius: 14, overflow: 'hidden', background: 'rgba(242, 242, 247, 0.97)', textAlign: 'center' }}>
        <div style={{ padding: '19px 16px 16px' }}>
          <div id="ios-close-title" data-testid="ios-close-title" style={{ fontSize: 17, fontWeight: 600, color: '#000' }}>
            {title}
          </div>
          <div data-testid="ios-close-message" style={{ marginTop: 4, fontSize: 13, color: '#000' }}>
            {message}
          </div>
        </div>
        <div style={{ display: 'flex', borderTop: '0.5px solid rgba(60,60,67,0.29)' }}>
          <button type="button" data-testid="ios-close-cancel" onClick={onCancel} style={{ ...action, fontWeight: 600, color: '#007AFF' }}>
            Cancel
          </button>
          <button
            type="button"
            data-testid="ios-close-confirm"
            onClick={onConfirm}
            style={{ ...action, color: '#FF3B30', borderLeft: '0.5px solid rgba(60,60,67,0.29)' }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  )
}

const action = {
  flex: 1,
  height: 44,
  border: 'none',
  background: 'transparent',
  fontSize: 17,
  cursor: 'pointer',
} as const
